interface ItemDeMenu {
  label?: string | null;
  page?: string | null;
  pai?: string | null;
  icon?: string | null;
}

export const PAGE_MINHAS_OPERADORAS = "posicaocontratoclienteconciliador";
const LABEL_MINHAS_OPERADORAS = "Minhas Operadoras";
const ICONE_MINHAS_OPERADORAS = "fa fa-credit-card-alt";

export const promoveMinhasOperadoras = <T extends ItemDeMenu>(menus: Array<T>): Array<T> =>
  menus.map((menu) =>
    menu.page === PAGE_MINHAS_OPERADORAS
      ? { ...menu, label: LABEL_MINHAS_OPERADORAS, pai: null, icon: ICONE_MINHAS_OPERADORAS }
      : menu
  );

export const posicionaMinhasOperadorasAntesDaAjuda = <T extends ItemDeMenu>(menus: Array<T>): Array<T> => {
  const minhasOperadoras = menus.find((menu) => menu.page === PAGE_MINHAS_OPERADORAS);
  const semMinhasOperadoras = menus.filter((menu) => menu !== minhasOperadoras);
  const posicaoAjuda = semMinhasOperadoras.findIndex((menu) => menu.label === "Ajuda");
  if (!minhasOperadoras || posicaoAjuda < 0) {
    return menus;
  }
  return [...semMinhasOperadoras.slice(0, posicaoAjuda), minhasOperadoras, ...semMinhasOperadoras.slice(posicaoAjuda)];
};
